import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c1093ed"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "m-logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "",
    src: "/assets/img/logo-small.svg"
  })
], -1))
const _hoisted_2 = { class: "volume-panel" }
const _hoisted_3 = {
  key: 0,
  class: "volume-catchcopy"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("再生"),
  /*#__PURE__*/_createElementVNode("rp", null, "（"),
  /*#__PURE__*/_createElementVNode("rt", null, "さいせい"),
  /*#__PURE__*/_createElementVNode("rp", null, "）")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("押"),
  /*#__PURE__*/_createElementVNode("rp", null, "（"),
  /*#__PURE__*/_createElementVNode("rt", null, "お"),
  /*#__PURE__*/_createElementVNode("rp", null, "）")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("音量"),
  /*#__PURE__*/_createElementVNode("rp", null, "（"),
  /*#__PURE__*/_createElementVNode("rt", null, "おんりょう"),
  /*#__PURE__*/_createElementVNode("rp", null, "）")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("調整"),
  /*#__PURE__*/_createElementVNode("rp", null, "（"),
  /*#__PURE__*/_createElementVNode("rt", null, "ちょうせい"),
  /*#__PURE__*/_createElementVNode("rp", null, "）")
], -1))
const _hoisted_8 = {
  key: 1,
  class: "volume-catchcopy"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("調整"),
  /*#__PURE__*/_createElementVNode("rp", null, "（"),
  /*#__PURE__*/_createElementVNode("rt", null, "ちょうせい"),
  /*#__PURE__*/_createElementVNode("rp", null, "）")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("終"),
  /*#__PURE__*/_createElementVNode("rp", null, "（"),
  /*#__PURE__*/_createElementVNode("rt", null, "お"),
  /*#__PURE__*/_createElementVNode("rp", null, "）")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("試験"),
  /*#__PURE__*/_createElementVNode("rp", null, "（"),
  /*#__PURE__*/_createElementVNode("rt", null, "しけん"),
  /*#__PURE__*/_createElementVNode("rp", null, "）")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("押"),
  /*#__PURE__*/_createElementVNode("rp", null, "（"),
  /*#__PURE__*/_createElementVNode("rt", null, "お"),
  /*#__PURE__*/_createElementVNode("rp", null, "）")
], -1))
const _hoisted_13 = ["src"]
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "control-btns" }
const _hoisted_16 = { class: "volume-btn" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("小"),
  /*#__PURE__*/_createElementVNode("rp", null, "（"),
  /*#__PURE__*/_createElementVNode("rt", null, "ちい"),
  /*#__PURE__*/_createElementVNode("rp", null, "）")
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("大"),
  /*#__PURE__*/_createElementVNode("rp", null, "（"),
  /*#__PURE__*/_createElementVNode("rt", null, "おお"),
  /*#__PURE__*/_createElementVNode("rp", null, "）")
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("ruby", null, [
    /*#__PURE__*/_createTextVNode("次"),
    /*#__PURE__*/_createElementVNode("rp", null, "（"),
    /*#__PURE__*/_createElementVNode("rt", null, "つぎ"),
    /*#__PURE__*/_createElementVNode("rp", null, "）")
  ]),
  /*#__PURE__*/_createTextVNode("へ")
], -1))
const _hoisted_20 = [
  _hoisted_19
]

import {ref, inject} from "vue"
import { useRoute, useRouter } from 'vue-router'
import { appKey, examKey } from "@/main";
import DemoControl from "@/components/parts/DemoControl.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Volume',
  emits: ['overridePageName'],
  setup(__props) {

const route = useRoute();
const router = useRouter();

const app = inject(appKey);
const exam = inject(examKey);


const group = route.params.group;
const volume = ref(3);
const imgUrl = ref('/assets/img/volume-lv1.svg');
const baseUrl = exam?.getAudioUrl();
const played = ref(false);

const isPlaying = ref(false);

const init = async () => {
  if (!exam) return;
  const session = await exam.session();
  updateVolume(session.volume);
}
init();

const up = () => {
  updateVolume(volume.value == 5 ? 5 : volume.value + 1);
  play();
}

const down = () => {
  updateVolume(volume.value == 1 ? 1 : volume.value - 1);
  play();
}

const updateVolume = (val: number) => {
  volume.value = val;
  imgUrl.value = `/assets/img/volume-lv${val}.svg`;
  const ratio = val == 5 ? 1.0 : 1.0 - ((5 - val) / 5.0);
  app?.setAudioVolume(ratio);
}

const play = () => {
  app?.playAudioUrl(baseUrl + 'sample.m4a', true);
  isPlaying.value = true;
  played.value = true;
}

const stopAudio = () => {
  app?.stopAudio();
  isPlaying.value = false;
}

const saveSession = async () => {
  if (!exam) return;
  const session = await exam.session();
  session.volume = volume.value;
  await exam.updateSession(session);
}

const next = async () => {
  exam?.startFullScreen();

  await saveSession();

  const session = await exam?.session();
  app?.stopAudio();

  if (!session) return;
  const resetData = await exam?.resetPart();
  if (resetData?.partNumber) {
    const questionType = resetData.questionType;
    const pageNumber = resetData.pageNumber;
    try {
      await exam?.listeningStart();
    } catch (e) {
      alert(e.message);
      await router.replace(`/cbt/${group}/login`);
    }
    if (questionType === 'reading') {
      await exam?.listeningEnd();
      await router.replace(`/cbt/${group}/reading-caution`);
    } else {
      await router.replace(`/cbt/${group}/listening/${pageNumber}/flow`);
    }
    return;
  }

  if (session.answer.listeningProgress > 0) {
    router.replace(`/cbt/${group}/listening/${session.answer.listeningProgress}`);
  }
  else {
    router.replace(`/cbt/${group}/exam-start`);
  }
}

const demoPrev = async () => {
  stopAudio();
  if (!exam) return;
  const session = await exam.session();
  if (!session) return;
  session.listeningStartTime = null;
  session.readingStartTime = null;
  exam.saveSession();
  router.replace(`/cbt/${group}/start`);
}
const demoNext = () => {
  app?.stopAudio();
  router.replace(`/cbt/${group}/exam-start`);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (!played.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
            _hoisted_4,
            _createTextVNode("ボタンを"),
            _hoisted_5,
            _createTextVNode("して「"),
            _hoisted_6,
            _createTextVNode("」を"),
            _hoisted_7,
            _createTextVNode("しましょう ")
          ]))
        : _createCommentVNode("", true),
      (played.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
            _hoisted_9,
            _createTextVNode("が"),
            _hoisted_10,
            _createTextVNode("わったら"),
            _hoisted_11,
            _createTextVNode("スタートボタンを"),
            _hoisted_12,
            _createTextVNode("しましょう ")
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("img", {
        alt: "",
        src: imgUrl.value,
        width: "120",
        height: "108",
        class: "volume-right"
      }, null, 8, _hoisted_13),
      _createElementVNode("img", {
        alt: "",
        src: imgUrl.value,
        width: "120",
        height: "108",
        class: "volume-left"
      }, null, 8, _hoisted_14),
      _createElementVNode("div", _hoisted_15, [
        (!isPlaying.value)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "audio_play",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (play()))
            }))
          : _createCommentVNode("", true),
        (isPlaying.value)
          ? (_openBlock(), _createElementBlock("span", {
              key: 1,
              class: "audio_stop",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (stopAudio()))
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("button", {
          class: "volume-btn__down",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (down()))
        }, [
          _hoisted_17,
          _createTextVNode("さく")
        ]),
        _createElementVNode("button", {
          class: "volume-btn__up",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (up()))
        }, [
          _hoisted_18,
          _createTextVNode("きく")
        ])
      ])
    ]),
    (played.value)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          onClick: _cache[4] || (_cache[4] = ($event: any) => (next())),
          class: "m-btn is-center"
        }, _hoisted_20))
      : _createCommentVNode("", true),
    _createVNode(DemoControl, {
      onPrev: demoPrev,
      onNext: demoNext
    })
  ], 64))
}
}

})